import { render } from "./EmailTestRecord.vue?vue&type=template&id=f0822300&scoped=true"
import script from "./EmailTestRecord.vue?vue&type=script&lang=js"
export * from "./EmailTestRecord.vue?vue&type=script&lang=js"

import "./EmailTestRecord.vue?vue&type=style&index=0&id=f0822300&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0822300"]])

export default __exports__